import { lazy } from 'react'

export const QuickWayVariant1 = lazy(() => import('./QuickWayVariant1'))
